import { combineReducers } from "@reduxjs/toolkit";
import { userReducer } from "./userReducer";
import fundsReducer from "./fundsSlice";
import strategiesReducer from "./strategiesSlice";
import custodianReducer from "./custodianSlice";
import brokerReducer from "./brokerSlice";
import securitiesReducer from "./securitiesSlice";
import reportsReducer from "./reportsSlice";
import lotsReducer from "./lotsSlice";
import marketDataReducer from "./marketDataSlice";
import tradesReducer from "./tradesSlice";
import rebalancerReducer from "./rebalancerSlice";
import managersReducer from "./managersSlice";
import notificationsReducer from "./notificationsSlice";
import accountingReducer from "./accountingSlice";
import tickersReducer from "./tickersSlice";
import routeReducer from "./routeSlice";
import ftpReducer from "./ftpSlice";
import uiReducer from "./uiSlice";
import strategyStoreReducer from "./strategyStoreSlice";
import { removeUser } from "../Actions/UserActions";

const appReducer = combineReducers({
  users: userReducer,
  funds: fundsReducer, // Funds use the new slice
  strategies: strategiesReducer, // Strategies use the new slice
  custodians: custodianReducer, // Custodians use the new slice
  brokers: brokerReducer, // Brokers use the new slice
  securities: securitiesReducer, // Securities use the new slice
  reports: reportsReducer, // Reports use the new slice
  lots: lotsReducer, // Lots use the new slice
  marketData: marketDataReducer, // MarketData use the new slice
  trades: tradesReducer, // Trades use the new slice
  rebalancer: rebalancerReducer, // Rebalancer use the new slice
  managers: managersReducer, // Managers use the new slice
  notifications: notificationsReducer, // Notifications use the new slice
  accounting: accountingReducer, // Accounting use the new slice
  tickers: tickersReducer, // Tickers use the new slice
  routes: routeReducer, // Routes use the new slice
  ftp: ftpReducer, // FTP use the new slice
  ui: uiReducer, // UI use the new slice
   strategyStore: strategyStoreReducer, 
});

const rootReducer = (state, action) => {
  if (action.type === removeUser.fulfilled.type) {
    localStorage.clear();
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
